import { createContext, useContext, type ReactNode } from "react";

export type IcbtTranslations = {
  REASSIGN: string;
  INITIATED_BY_PATIENT: string;
  COMPLETED: string;
  IN_PROGRESS: string;
  NOT_STARTED: string;
  ICBT_LOADING_DATA_ERROR_FORBIDDEN: string;
  ICBT_LOADING_DATA_ERROR: string;
  ICBT_PROGRAM_PAGE_BY_PAGE: string;
  OF: string;
  ADD_FEEDBACK_DATE: string;
  ASSIGN: string;
  CANCEL: string;
  SEARCH: string;
  PROGRAMS_ASSIGNED: string;
  VIEW_ICBT_PAGE: string;
  NO_ANSWER: string;
  icbtsToAssign: (count: number) => string;
};

export const defaultTranslations: IcbtTranslations = {
  REASSIGN: "Reassign",
  INITIATED_BY_PATIENT: "Initiated by patient",
  COMPLETED: "Completed",
  IN_PROGRESS: "In progress",
  NOT_STARTED: "Not started",
  ICBT_LOADING_DATA_ERROR_FORBIDDEN:
    "You don't have permission to load this data",
  ICBT_LOADING_DATA_ERROR: "Error loading data",
  ICBT_PROGRAM_PAGE_BY_PAGE: "Program page by page",
  OF: "of",
  ADD_FEEDBACK_DATE: "Add feedback date",
  ASSIGN: "Assign",
  CANCEL: "Cancel",
  SEARCH: "Search",
  PROGRAMS_ASSIGNED: "Programs assigned",
  VIEW_ICBT_PAGE: "View ICBT page",
  NO_ANSWER: "No answer",
  icbtsToAssign: (count: number) =>
    `${count} ${count === 1 ? "program" : "programs"} selected`,
};

export const IcbtTranslationContext =
  createContext<IcbtTranslations>(defaultTranslations);

export const IcbtTranslationProvider = ({
  translations,
  children,
}: {
  translations: IcbtTranslations;
  children: ReactNode;
}) => (
  <IcbtTranslationContext.Provider value={translations}>
    {children}
  </IcbtTranslationContext.Provider>
);

export const useIcbtTranslation = () => useContext(IcbtTranslationContext);
